import styled, { css } from 'styled-components';
import { StyledButton } from '../../globalStyled';
import { fontDisplay, fontUi } from '../../theme/typography';

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
`;

export const StyledTitle = styled.h1`
  ${fontDisplay};
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: -0.02em;
  text-transform: none;
  color: ${({ theme }) => theme.text};
  margin: 0;
`;

export const StyledOwnedToggle = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledOwnedLabel = styled.label`
  ${fontUi};
  margin-right: 10px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  cursor: pointer;
`;

export const StyledStuffButton = styled(StyledButton)`
  transition: none;
  margin: 0;
  width: 100%;
  min-width: 0;
  font-size: 13px;
  padding: 10px 12px;
  box-shadow: none;
  && {
    ${({ disabled, yellow, blue, primary, theme }) => {
      if (disabled) {
        return css`
          background-color: ${theme.hover};
          color: ${theme.textFaint};
          border-color: ${theme.border};
        `;
      }
      if (yellow || blue) {
        return null;
      }
      if (theme.isDark && primary) {
        return css`
          background: transparent;
          color: ${theme.text};
          border: 1px solid ${theme.border};
          &:hover:not(:disabled) {
            background: ${theme.hover};
          }
        `;
      }
      return null;
    }}
  }
`;

export const StyledStuffContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  overflow: hidden;
  img {
    border-radius: 0;
    max-height: 195px;
  }
`;

export const StyledStuffImageContainer = styled.div`
  border-radius: ${({ theme }) => theme.cardRadius};
`;

export const StyledStuffImage = styled.img`
  max-width: 100%;
  object-fit: contain;
`;

export const StyledStuffList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18%, 1fr));
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  @media only screen and (max-width: 991px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }
  @media only screen and (max-width: 599px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const StyledNameBlock = styled.div`
  ${fontUi};
  min-height: 36px;
  box-sizing: border-box;
  overflow-wrap: anywhere;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  font-weight: 600;
`;

export const StyledImgContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  height: 240px;
  @media (max-width: 991px) {height: 160px; img {max-height:140px;max-width:100%;}}
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.card};
`;

export const StyledButtonWrap = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px 12px;
`;

export const StyledStuffWrapper = styled.div`
  min-width: 0;
  ${({ $current, theme }) =>
    $current &&
    css`
      ${StyledStuffContainer} {
        background: ${theme.accentSoft};
        border-color: ${theme.accent};
      }
    `}
  ${({ $current, disabled, theme }) => {
    if (!disabled && !$current) {
      return css`
        &:hover ${StyledStuffContainer} {
          background: ${theme.hover};
        }
      `;
    }
    if (disabled) {
      return css`
        cursor: default;
        img {
          opacity: 0.3;
        }
      `;
    }
    return null;
  }}
`;

export const StyledEmpty = styled.p`
  ${fontUi};
  color: ${({ theme }) => theme.textFaint};
  font-size: 14px;
  margin: 40px 0;
  text-align: center;
`;
